import { Box, Icon, Text } from '@nimbus-ds/components';
import { MoneyIcon } from '@nimbus-ds/icons';
import { AbandonedCartPaymentAttemptDto } from '@tiendanube/common';
import { PAYMENT_METHOD_TYPE_ICONS } from 'domains/Payments/PaymentProviders/components/utils';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

interface PaymentMethodTitleProps {
  attempt: AbandonedCartPaymentAttemptDto;
}

export function PaymentMethodTitle({
  attempt,
}: Readonly<PaymentMethodTitleProps>) {
  const t = useTranslationPayments('paymentProvider');

  const paymentMethod = attempt.payment?.paymentMethod ?? '';
  const appName = attempt.appName;

  const PaymentIcon = PAYMENT_METHOD_TYPE_ICONS[paymentMethod] ?? MoneyIcon;
  if (!paymentMethod && !appName) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center" gap="2">
      <Icon source={<PaymentIcon />} />
      {!!paymentMethod && (
        <Text color="neutral-textHigh">
          {t(`method.${paymentMethod}`, paymentMethod)}
        </Text>
      )}
      {!!paymentMethod && !!appName && (
        <Box
          width="1px"
          height="16px"
          backgroundColor="neutral-surfaceHighlight"
        />
      )}
      {!!appName && <Text color="neutral-textHigh">{appName}</Text>}
    </Box>
  );
}
